import TransactionValueDashlet from './TransactionValueDashlet';

export default TransactionValueDashlet;
